import React, { Component } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import payment from '../../../assets/img/premium/payment.svg'
import paypal from '../../../assets/img/premium/paypal.svg'
import credit from '../../../assets/img/premium/credit.svg'
import cash from '../../../assets/img/premium/cash.svg'
import PaymentSuccess from './paymentsuccess';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import loaderjson from '../../../assets/json/loader.json';
import Lottie from "lottie-react";
import { Trans } from "react-i18next";   
import "../../../config/i18n";
import { withTranslation } from "react-i18next";

class Payment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedOption: '',
            paymentsuccessmodal:false,
            api_url: localStorage.getItem('api_url'),
            langKey: 'en',
            showLoader: 0,
        };
    }

    async componentDidMount() {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const session_id = params.get('session_id');
        const reference = params.get('reference');
        if(session_id !== null ){
            this.setState({
                showLoader: 1
            });   
            var paymentSes = new FormData();
            paymentSes.set('price', JSON.parse(localStorage.getItem('premium_price')));
            paymentSes.set('discount_id', JSON.parse(localStorage.getItem('discount_id')));
            paymentSes.set('original_price', JSON.parse(localStorage.getItem('original_price')));
            paymentSes.set('discount_price', JSON.parse(localStorage.getItem('discount_price')));
            paymentSes.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
            paymentSes.set('boost_id', JSON.parse(localStorage.getItem('selected_premium')));
            paymentSes.set('language', this.state.langKey);   
            paymentSes.set('session_id', session_id); 

            paymentSes.set('language', this.state.langKey);
            paymentSes.set('session_id', session_id);
            axios({
                method: 'post',
                url: this.state.api_url+'stripeboostretrievesession',
                data: paymentSes,
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
            }).then(res => {
                this.setState({
                    showLoader: 0
                });   
                localStorage.setItem('selected_premium', '');
                localStorage.setItem('premium_price', '');
                if (res.data.status === "true") {
                    localStorage.setItem('superlike_premium_popup', '1');
                    this.setState({ profilepage: true });
                } else {
                    this.setState({ profilepage: true });
                }
            })
        }
        //Chapa
        if(reference !== null ){
            this.setState({
                showLoader: 1 
            });   
            var paymentRef = new FormData();
            paymentRef.set('price', JSON.parse(localStorage.getItem('premium_price')));
            paymentRef.set('discount_id', JSON.parse(localStorage.getItem('discount_id')));
            paymentRef.set('original_price', JSON.parse(localStorage.getItem('original_price')));
            paymentRef.set('discount_price', JSON.parse(localStorage.getItem('discount_price')));
            paymentRef.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
            paymentRef.set('boost_id', JSON.parse(localStorage.getItem('selected_premium')));
            paymentRef.set('language', this.state.langKey);   
            paymentRef.set('reference', reference);  
            axios({
                method: 'post',
                url: this.state.api_url+'chapaboostretrievesession',
                data: paymentRef,
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
            }).then(res => {
                this.setState({
                    showLoader: 0
                });   
                localStorage.setItem('selected_premium', '');
                localStorage.setItem('premium_price', '');
                if (res.data.status === "true") {
                    localStorage.setItem('superlike_premium_popup', '1');
                    this.setState({ profilepage: true });
                } else {
                    this.setState({ profilepage: true });
                }
            })
        }
    }

    handleOptionChange = (changeEvent) => {
        const newSelectedOption = changeEvent.target.value;
        this.setState({
            selectedOption: newSelectedOption
        }, () => {
            console.log("selectedOption:", this.state.selectedOption);
        });
    };

    handlePaymentSuccessOpenModal = () => {
        if(this.state.selectedOption === null || this.state.selectedOption === '') {
            this.setState({ noboostpayment: 'Please select any one payment method' });
            setTimeout(() => {
                this.setState({
                    noboostpayment: ''
                });
            }, 2000);
        } else {
            this.props.handleClose();
            if(this.state.selectedOption === "stripe"){
                this.stripepayment();
            }else if(this.state.selectedOption === "chapa"){
                this.chapapayment();
            }else if(this.state.selectedOption === "cash"){
                this.cashpayment();
            }
        }
    }

    handlePaymentSuccessCloseModal = () => {
        this.setState({ paymentsuccessmodal: false });
    }

    stripepayment (){
        var payment = new FormData();
        payment.set('price', JSON.parse(localStorage.getItem('premium_price')));
        payment.set('discount_id', JSON.parse(localStorage.getItem('discount_id')));
        payment.set('original_price', JSON.parse(localStorage.getItem('original_price')));
        payment.set('discount_price', JSON.parse(localStorage.getItem('discount_price')));
        payment.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        payment.set('boost_id', JSON.parse(localStorage.getItem('selected_premium')));
        payment.set('language', this.state.langKey);   
        axios({
            method: 'post', 
            url: this.state.api_url+'stripewebpayboost',
            data: payment, 
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            console.log('..........rrrrrrrrrrrr',res)
            if (res.data.status === "true") {
                window.location.href = res.data.session_url; 
            }else{
                alert('something went wrong')
            }
        })
    }

    chapapayment (){
        var payment = new FormData();
        payment.set('price', JSON.parse(localStorage.getItem('premium_price')));
        payment.set('discount_id', JSON.parse(localStorage.getItem('discount_id')));
        payment.set('original_price', JSON.parse(localStorage.getItem('original_price')));
        payment.set('discount_price', JSON.parse(localStorage.getItem('discount_price')));
        payment.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        payment.set('boost_id', JSON.parse(localStorage.getItem('selected_premium')));
        payment.set('language', this.state.langKey);  
        axios({
            method: 'post', 
            url: this.state.api_url+'chapawebpayboost',
            data: payment, 
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            console.log('..........rrrrrrrrrrrr',res)
            if (res.data.status === "true") {
                window.location.href = res.data.session_url; 
            }else{
                alert('something went wrong')
            }
        })
    }

    cashpayment() {
        var cashpayment = new FormData();
        cashpayment.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        cashpayment.set('purchase_id', JSON.parse(localStorage.getItem('selected_premium')));
        cashpayment.set('price', JSON.parse(localStorage.getItem('premium_price')));
        cashpayment.set('discount_id', JSON.parse(localStorage.getItem('discount_id')));
        cashpayment.set('original_price', JSON.parse(localStorage.getItem('original_price')));
        cashpayment.set('discount_price', JSON.parse(localStorage.getItem('discount_price')));
        cashpayment.set('currency_code', JSON.parse(localStorage.getItem('currency')));
        cashpayment.set('plan_type', 'boost'); 
        cashpayment.set('language', this.state.langKey);   
        axios({
            method: 'post',
            url: this.state.api_url+'paywithcashweb',
            data: cashpayment,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        .then(res => {
            if (res.data.status === "true") {
                localStorage.setItem('selected_premium', '');
                localStorage.setItem('premium_price', '');
                this.setState({ paymentsuccessmodal: true });
            }else{
                this.setState({ 
                    successMessage: res.data.message,
                    suc_cls: 'successMsg floatingAlerts1'
                });
                setTimeout(() => {
                    this.setState({
                        suc_cls: 'successMsghide'
                    });
                }, 3000);
            }
        });

    }

    render() {

        if (this.state.profilepage) {
            return <Redirect to="/profile" />;
        }

        const checkedRadioStyle = {
            color: '#fff',
        };

        return (
            <>
                <div className="">
                    <div className='payment_loader'>
                        <Lottie animationData={(this.state.showLoader === 1) ? loaderjson : ''} className='' />
                    </div>
                    <Modal className="modal_div joinplan_modal" show={this.props.showModal} onHide={this.props.handleClose} centered>
                        <Modal.Header>
                            <Modal.Title><Trans i18nKey="Select Payment Method">Select Payment Method</Trans></Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="religion_modal selectplan_height">
                            <div className=''>
                                <div className="payment_img">
                                    <img src={payment} alt="img" />
                                </div>
                                <div className='selectplan_select payment_form'>
                                    <Form.Group controlId="formPlaintextEmail" className={`language_formgroup selectplan_formgroup ${this.state.selectedOption === 'stripe' ? 'common_language' : ''}`}>
                                        <Form.Check.Label htmlFor="paypalRadio">
                                            <img src={paypal} alt="img" />
                                            <span style={this.state.selectedOption === 'stripe' ? checkedRadioStyle : null}>Stripe</span>
                                        </Form.Check.Label>
                                        <Form.Check
                                            type="radio"
                                            id="paypalRadio"
                                            name="radioGroup"
                                            value="stripe"
                                            checked={this.state.selectedOption === 'stripe'}
                                            onChange={this.handleOptionChange}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="formPlaintextEmail" className={`language_formgroup selectplan_formgroup ${this.state.selectedOption === 'chapa' ? 'common_language' : ''}`}>
                                        <Form.Check.Label htmlFor="creditRadio">
                                            <img src={credit} alt="img" />
                                            <span style={this.state.selectedOption === 'chapa' ? checkedRadioStyle : null}>Chapa</span>
                                        </Form.Check.Label>
                                        <Form.Check
                                            type="radio"
                                            id="creditRadio"
                                            name="radioGroup"
                                            value="chapa"
                                            checked={this.state.selectedOption === 'chapa'}
                                            onChange={this.handleOptionChange}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="formPlaintextEmail" className={`language_formgroup selectplan_formgroup ${this.state.selectedOption === 'cash' ? 'common_language' : ''}`}>
                                        <Form.Check.Label htmlFor="cashRadio">
                                            <img src={cash} alt="img" />
                                            <span style={this.state.selectedOption === 'cash' ? checkedRadioStyle : null}>Cash</span>
                                        </Form.Check.Label>
                                        <Form.Check
                                            type="radio"
                                            id="cashRadio"
                                            name="radioGroup"
                                            value="cash"
                                            checked={this.state.selectedOption === 'cash'}
                                            onChange={this.handleOptionChange}
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                        </Modal.Body>
                        <div className="errorMsg" style={{ paddingLeft: "100px" }}>{this.state.noboostpayment}</div>
                        <Modal.Footer className="forgot_button_plr">
                            <Button className='button_primary' onClick={this.handlePaymentSuccessOpenModal} >
                                <Trans i18nKey="CONTINUE">CONTINUE</Trans>
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
                <PaymentSuccess
                    showModal={this.state.paymentsuccessmodal}
                    handleClose={this.handlePaymentSuccessCloseModal}
                />
            </>
        );
    }
}

export default Payment;